import { ApiLink } from "../APILink/ApiLink";

// Dedicated fetch calls avoid altering global Axios behavior or auth error handlers.
export function sendMonitoringEvent(kind) {
  try {
    if (kind !== "activity" && kind !== "logout") return;
    const token = localStorage.getItem("token");
    if (!token) return;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    try {
      Promise.resolve(fetch(`${ApiLink.API_URL}access-monitoring/session/${kind}`, {
        method: "POST", headers: { Authorization: `Bearer ${token}` },
        signal: controller.signal, keepalive: kind === "logout",
      })).catch(() => {}).finally(() => clearTimeout(timeout));
    } catch { clearTimeout(timeout); }
  } catch { /* Monitoring must not interrupt navigation or logout. */ }
}

export function startAccessMonitoringActivity() {
  let lastInteraction = Date.now();
  const touch = () => { lastInteraction = Date.now(); };
  const events = ["pointerdown", "keydown", "scroll", "touchstart"];
  events.forEach(event => window.addEventListener(event, touch, { passive: true }));
  const pulse = () => {
    // A hidden/idle tab is not evidence of continued use.
    if (document.visibilityState === "visible" && Date.now() - lastInteraction < 120000)
      sendMonitoringEvent("activity");
  };
  const visible = () => { if (document.visibilityState === "visible") { touch(); pulse(); } };
  document.addEventListener("visibilitychange", visible);
  pulse();
  const timer = setInterval(pulse, 60000);
  return () => {
    clearInterval(timer);
    events.forEach(event => window.removeEventListener(event, touch));
    document.removeEventListener("visibilitychange", visible);
  };
}
